const product = [{
    id: 1,
    name: 'Over-Ear Headphones (Black)',
    price: 3900,
    image: require('./images/1.jpg'),
    details:'Quality headphones for you at an affordable price.',
    count : 1
},
{
    id: 2,
    name: 'Apple iPhone 128GB',
    price: 12000,
    image: require('./images/2.jpg'),
    details:
        'High quality smartphone that you will love.',
},
{
    id: 3,
    name: 'Running Shoe Red & White',
    price: 2500,
    image: require('./images/3.jpg'),
    details:
        'Cool shoes, comfortable, beautiful design.',
},
{
    id: 4,
    name: 'Apple iPhone Blue 64GB',
    price: 8999,
    image: require('./images/4.jpg'),
    details:
        'High quality smartphone that you will love.',
},
{
    id: 5,
    name: 'Over-Ear Headphones (White)',
    price: 3599,
    image: require('./images/5.jpg'),
    details:
        'Quality headphones for you at an affordable price.',
},
{
    id: 6,
    name: 'Gamepad White for PC/PS3',
    price: 520,
    image: require('./images/6.jpg'),
    details:
        'Quality game controller that you will like.',
},
{
    id: 7,
    name: 'Premium Smart Watch (Black)',
    price: 7599,
    image: require('./images/7.jpg'),
    details:
        'A high quality smartwatch at an affordable price.',
},
{
    id: 8,
    name: 'Multicolor Modern Shoe',
    price: 3999,
    image: require('./images/8.jpg'),
    details:
        'modern shoes Suitable for a beautiful woman like you.',
},
{
    id: 9,
    name: 'Apple iPhone (Brand New)',
    price: 9999,
    image: require('./images/9.jpg'),
    details:
        'High quality smartphone that you will love.',
},
{
    id: 10,
    name: 'Smart Watch with Latest Android OS',
    price: 7599,
    image: require('./images/10.jpg'),
    details:
        'A high quality smartwatch at an affordable price.',
},
{
    id: 11,
    name: 'Modern & Original Eye Glasses',
    price: 999,
    image: require('./images/11.jpg'),
    details:
        'cool sunglasses Suitable for cool people like you.',
},
{
    id: 12,
    name: 'Nikon Camera (Slightly Used) 750',
    price: 15999,
    image: require('./images/12.jpg'),
    details:
        'The Nikon Camera is sharp in every shot.',
},
{
    id: 13,
    name: 'Red & Black Ganming Mouse for PC',
    price: 799,
    image: require('./images/13.jpg'),
    details:
        'Quality gaming mouse that flows smoothly in every moment.',
},
{
    id: 14,
    name: 'Multi Purpose College Bag Backpack',
    price: 699,
    image: require('./images/14.jpg'),
    details:
        'Bag Backpack, good quality, easy to carry.',
},
{
    id: 15,
    name: 'White & Black Watch Concept',
    price: 1500,
    image: require('./images/15.jpg'),
    details:
        'A stylish watch for a cool person like you.',
}]

export default product;